module.exports = __webpack_public_path__ + "fb2ecf1a4d64ee9c1af51606d7fe9a0b.avi";